/* globals angular */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('QuickFilterEditorModel', ['ExplorerUtils', 'PeoplePickerUtils', 'VerbPickerUtils', '$q', 'CustomDateFilter', 'User', 'UserRoles', function (ExplorerUtils, PeoplePickerUtils, VerbPickerUtils, $q, CustomDateFilter, User, UserRoles) {
    var dialogChoice;
    var dialog;
    var pickerConfig;
    var quickFilter;

    // This is the model that we're directly modifying; for a report within
    // report builder, it's probably a reference to the $scope.workingConfig object, but for card-groups, it's a
    // reference to that card-group.
    var referenceModel;
    function resetPickerSpecificViewSettings() {
      quickFilter.dialogChoice = {
        picker: false,
        pickerLoading: false
      };
    }

    // @param type String - May be one of ['activities', 'people', 'verbs', 'dates]
    function openQuickFilterDialog(type) {
      resetPickerSpecificViewSettings();
      quickFilter.pickerConfig.dialogChoice = quickFilter.dialogChoice;
      var pickerConfig = "".concat(type, "Config");
      quickFilter.dialogChoice[pickerConfig] = true;
      quickFilter.dialogChoice.picker = true;
      if (quickFilter[pickerConfig] && quickFilter[pickerConfig].buildPicker) {
        quickFilter[pickerConfig].buildPicker();
      } else {
        throw new Error('buildPicker function should be defined on the quickFilter');
      }
    }

    // @param referenceConfig Object - Should match type: { quickFilters: { people: {...}, verbs: {...}, activities: {...} } }
    function applyWorkingConfigQuickFiltersToModel(referenceConfig, quickFilter) {
      ExplorerUtils.populateSimpleModeScope(referenceConfig.quickFilters.people.filter, quickFilter);
      ExplorerUtils.populateSimpleModeScope(referenceConfig.quickFilters.verbs.filter, quickFilter);
      ExplorerUtils.populateSimpleModeScope(referenceConfig.quickFilters.activities.filter, quickFilter);
    }
    return {
      // @param referenceType String - Must be one of 'report' or 'dashboard'
      getTypeOptions: function getTypeOptions(referenceType) {
        return function (quickFilterType) {
          var options = {
            report: ['all', 'custom', 'report', 'disabled'],
            cardGroup: ['all', 'custom', 'disabled']
          };
          if (quickFilterType === 'dates') {
            return options[referenceType].filter(function (o) {
              return o !== 'report';
            });
          } else {
            return options[referenceType];
          }
        };
      },
      getQuickFilters: function getQuickFilters() {
        return quickFilter;
      },
      init: function init(incomingReferenceModel) {
        referenceModel = incomingReferenceModel;
        dialogChoice = {
          picker: false,
          pickerLoading: false
        };
        dialog = {
          show: false
        };
        pickerConfig = {
          dialogHeight: '1000px',
          dialogChoice: dialogChoice,
          dialog: dialog
        };
        quickFilter = {
          dialog: dialog,
          dialogChoice: dialogChoice,
          pickerConfig: pickerConfig,
          peoplePickerConfig: {
            selectedPeopleOrGroups: [],
            excludedPeopleOrGroups: [],
            immutableSelection: [],
            intersectGroups: false,
            intersectExcludedGroups: false,
            pickerConfig: pickerConfig,
            personPicker: {
              singlePerson: false
            },
            hidePII: UserRoles.isConsultant(User.get()),
            personOrGroupSelected: function personOrGroupSelected(personOrGroup, immutable) {
              personOrGroup.showIcons = false;
              var notCurrentlySelected = !PeoplePickerUtils.isPersonOrGroupSelected(personOrGroup, this);
              if (notCurrentlySelected) {
                if (immutable) {
                  this.immutableSelection.push(personOrGroup);
                } else {
                  this.selectedPeopleOrGroups.push(personOrGroup);
                }
              }
            },
            removePersonOrGroup: function removePersonOrGroup(personOrGroup, isExcluded) {
              var self = this;
              var key = PeoplePickerUtils.personOrGroupKey(personOrGroup);
              if (isExcluded) {
                this.excludedPeopleOrGroups = self.excludedPeopleOrGroups.filter(function (item) {
                  return PeoplePickerUtils.personOrGroupKey(item) === key;
                });
              } else {
                this.selectedPeopleOrGroups = self.selectedPeopleOrGroups.filter(function (item) {
                  return PeoplePickerUtils.personOrGroupKey(item) === key;
                });
              }
            },
            excludePersonOrGroup: function excludePersonOrGroup(personOrGroup) {
              personOrGroup.showIcons = false;
              this.excludedPeopleOrGroups.push(personOrGroup);
              this.removePersonOrGroup(personOrGroup);
            }
          },
          activityPickerConfig: {
            selectedActivities: [],
            excludedActivities: [],
            immutableSelection: [],
            pickerConfig: pickerConfig,
            require: {
              activity: false
            },
            addActivity: function addActivity(activity, immutable) {
              var self = this;
              activity.showIcons = false;
              function isSelectedActivityOrActivityType(activity) {
                var actIds;
                if (activity.activityId) {
                  actIds = _.pluck(self.selectedActivities, 'activityId');
                  return _.contains(actIds, activity.activityId);
                } else {
                  actIds = _.pluck(self.selectedActivities, 'id');
                  return _.contains(actIds, activity.id);
                }
              }
              if (!isSelectedActivityOrActivityType(activity)) {
                if (immutable) {
                  this.immutableSelection.push(activity);
                } else {
                  this.selectedActivities.push(activity);
                }
              }
            },
            removeActivity: function removeActivity(activity, isExcluded) {
              var self = this;
              if (isExcluded) {
                this.excludedActivities = _.reject(self.excludedActivities, function (act) {
                  if (act.activityId) {
                    return act.activityId === activity.activityId;
                  } else {
                    return act.id === activity.id;
                  }
                });
              } else {
                this.selectedActivities = _.reject(self.selectedActivities, function (act) {
                  if (act.activityId) {
                    return act.activityId === activity.activityId;
                  } else {
                    return act.id === activity.id;
                  }
                });
              }
            },
            excludeActivity: function excludeActivity(activity) {
              activity.showIcons = false;
              this.excludedActivities.push(activity);
              this.removeActivity(activity);
            }
          },
          verbPickerConfig: {
            selectedVerbs: [],
            excludedVerbs: [],
            immutableSelection: [],
            pickerConfig: pickerConfig,
            addVerb: function addVerb(verb, immutable) {
              verb.showIcons = false;
              // Partially-applied, so call both functions at once
              if (!VerbPickerUtils.isSelectedVerb(this)(verb)) {
                if (immutable) {
                  this.immutableSelection.push(verb);
                } else {
                  this.selectedVerbs.push(verb);
                }
              }
            }
          },
          datePickerConfig: {
            dateFilter: {
              dateType: 'none',
              trailingAmount: 1,
              trailingType: 'days',
              customDateFrom: null,
              customDateTo: null
            }
          }
        };
        applyWorkingConfigQuickFiltersToModel(referenceModel, quickFilter);
        quickFilter.peoplePickerConfig.openDialog = openQuickFilterDialog;
        quickFilter.verbPickerConfig.openDialog = openQuickFilterDialog;
        quickFilter.activityPickerConfig.openDialog = openQuickFilterDialog;
        quickFilter.datePickerConfig.openDialog = openQuickFilterDialog;
      },
      // @param filterName String - One of: ['people', activities', 'verbs', 'dates']
      setTypeFor: function setTypeFor(filterName) {
        return function setQuickFilterType(selection) {
          var quickFilterObj = {
            type: selection
          };
          if (selection === 'custom') {
            quickFilterObj.filter = {
              activityIds: null,
              personIds: null,
              groupIds: null,
              dateFilter: {
                dateType: 'none',
                trailingAmount: 1,
                trailingType: 'days',
                customDateFrom: null,
                customDateTo: null
              }
            };
          }
          referenceModel.quickFilters[filterName] = quickFilterObj;
        };
      },
      saveQuickFilters: function saveQuickFilters() {
        if (!quickFilter) {
          return;
        }
        var _quickFilter$peoplePi = quickFilter.peoplePickerConfig,
          selectedPeopleOrGroups = _quickFilter$peoplePi.selectedPeopleOrGroups,
          excludedPeopleOrGroups = _quickFilter$peoplePi.excludedPeopleOrGroups;
        var _quickFilter$activity = quickFilter.activityPickerConfig,
          selectedActivities = _quickFilter$activity.selectedActivities,
          excludedActivities = _quickFilter$activity.excludedActivities;
        var _quickFilter$verbPick = quickFilter.verbPickerConfig,
          selectedVerbs = _quickFilter$verbPick.selectedVerbs,
          excludedVerbs = _quickFilter$verbPick.excludedVerbs;

        // People, Groups, and Group Types
        if (referenceModel.quickFilters.people.type === 'custom') {
          var people = {
            type: 'custom',
            filter: {}
          };
          people.filter.personIds = selectedPeopleOrGroups.filter(function (p) {
            return p.personas;
          }).map(function (p) {
            return p.id;
          });
          people.filter.groupIds = selectedPeopleOrGroups.filter(function (g) {
            return !g.personas && g.peopleIds;
          }).map(function (g) {
            return g.id;
          });
          people.filter.groupTypeNames = selectedPeopleOrGroups.filter(function (t) {
            return !t.personas && !t.peopleIds;
          }).map(function (t) {
            return t.name;
          });
          var notFilter = {};
          var notPersonIds = excludedPeopleOrGroups.filter(function (p) {
            return p.personas;
          }).map(function (p) {
            return p.id;
          });
          var notGroupIds = excludedPeopleOrGroups.filter(function (g) {
            return !g.personas && g.peopleIds;
          }).map(function (g) {
            return g.id;
          });
          var notGroupTypeNames = excludedPeopleOrGroups.filter(function (t) {
            return !t.personas && !t.peopleIds;
          }).map(function (t) {
            return t.name;
          });
          if (notPersonIds.length) {
            notFilter.personIds = notPersonIds;
          }
          if (notGroupIds.length) {
            notFilter.groupIds = notGroupIds;
          }
          if (notGroupTypeNames.length) {
            notFilter.groupTypeNames = notGroupTypeNames;
          }
          if (notPersonIds.length || notGroupIds.length || notGroupTypeNames.length) {
            people.filter.not = {
              or: [notFilter]
            };
          }
          referenceModel.quickFilters.people = people;
        }

        // Activities
        if (referenceModel.quickFilters.activities.type === 'custom') {
          var activities = {
            type: 'custom',
            filter: {}
          };
          var activityIds = selectedActivities.filter(function (a) {
            return a.activityId;
          }).map(function (a) {
            return a.activityId;
          });
          var activityTypes = selectedActivities.filter(function (a) {
            return !a.activityId;
          }).map(function (a) {
            return a.id;
          });
          if (activityIds.length) {
            activities.filter.activityIds = {
              ids: activityIds
            };
          }
          if (activityTypes.length) {
            activities.filter.activityTypes = activityTypes;
          }
          var _notFilter = {};
          var notActivityIds = excludedActivities.filter(function (a) {
            return a.activityId;
          }).map(function (a) {
            return a.activityId;
          });
          var notActivityTypes = excludedActivities.filter(function (a) {
            return !a.activityId;
          }).map(function (a) {
            return a.id;
          });
          if (notActivityIds.length) {
            _notFilter.activityIds = {
              ids: notActivityIds
            };
          }
          if (notActivityTypes.length) {
            _notFilter.activityTypes = notActivityTypes;
          }
          if (notActivityIds.length || notActivityTypes.length) {
            activities.filter.not = {
              or: [_notFilter]
            };
          }
          referenceModel.quickFilters.activities = activities;
        }

        // Verbs
        if (referenceModel.quickFilters.verbs.type === 'custom') {
          var verbs = {
            type: 'custom',
            filter: {}
          };
          var verbIds = selectedVerbs.map(function (v) {
            return v.verbId;
          });
          if (verbIds.length) {
            verbs.filter.verbIds = {
              ids: verbIds
            };
          }
          var notVerbIds = excludedVerbs.map(function (v) {
            return v.verbId;
          });
          if (notVerbIds.length) {
            verbs.filter.not = {
              or: [{
                ids: notVerbIds
              }]
            };
          }
          referenceModel.quickFilters.verbs = verbs;
        }
      },
      saveCustomDateFilter: function saveCustomDateFilter() {
        return $q(function (resolve, reject) {
          CustomDateFilter.clearError();
          var customDateType = CustomDateFilter.dateFilter.dateType === 'custom';
          var missingFromDate = !CustomDateFilter.dateFilter.customDateFrom;
          var missingToDate = !CustomDateFilter.dateFilter.customDateTo;
          var userDidNotSelectCustomDates = customDateType && (missingFromDate || missingToDate);
          if (userDidNotSelectCustomDates) {
            CustomDateFilter.error = 'Please choose a "From" and a "To" date';
            reject();
            return;
          }
          var dateFilter = {
            name: CustomDateFilter.name,
            dateFilter: CustomDateFilter.dateFilter
          };
          var hasCustomDates = referenceModel.quickFilters.dates.customDates && referenceModel.quickFilters.dates.customDates instanceof Array;
          if (hasCustomDates) {
            var editingExistingCustomDateFilter = CustomDateFilter.index !== null && referenceModel.quickFilters.dates.customDates[CustomDateFilter.index];
            if (editingExistingCustomDateFilter) {
              referenceModel.quickFilters.dates.customDates[CustomDateFilter.index] = dateFilter;
            } else {
              referenceModel.quickFilters.dates.customDates.push(dateFilter);
            }
          } else {
            referenceModel.quickFilters.dates.customDates = [dateFilter];
          }

          // Date filters do not need a filter property; so remove it from the model
          delete referenceModel.quickFilters.dates.filter;
          resolve();
        });
      },
      deleteCustomDateFilter: function deleteCustomDateFilter(index) {
        return $q(function (resolve, reject) {
          if (!index) {
            resolve();
          }
          try {
            var dates = referenceModel.quickFilters.dates.customDates;
            referenceModel.quickFilters.dates.customDates = dates.filter(function (d, i) {
              return i !== index;
            });
            resolve();
          } catch (err) {
            reject();
          }
        });
      },
      revertCustomDateFilter: function revertCustomDateFilter(index) {
        return $q(function (resolve, reject) {
          if (!index) {
            resolve();
          }
          try {
            referenceModel.quickFilters.dates.customDates[index] = CustomDateFilter.revertCustomDateFilterChanges(referenceModel.quickFilters.dates.customDates[index]);
            resolve();
          } catch (err) {
            reject();
          }
        });
      },
      saveAndIgnoreErrors: function saveAndIgnoreErrors() {
        var self = this;
        return $q(function (resolve, reject) {
          self.saveQuickFilters();
          if (CustomDateFilter.showCreationView) {
            self.saveCustomDateFilter().then(function () {
              resolve();
            }).catch(function () {
              reject();
            }).finally(function () {
              CustomDateFilter.reset();
            });
          }
        });
      }
    };
  }]);
})(this);
